import { CtaBookNow } from 'themes/playful/components/CtaBookNow/CtaBookNow';
import { CtaViewMore } from 'themes/playful/components/CtaViewMore/CtaViewMore';
import { PlayfulTeamList } from 'themes/playful/components/Team/PlayfulTeamList';
import { TextureSection } from 'themes/playful/components/TextureSection/TextureSection';

import { useAboutPage } from 'hooks/page/about/useAboutPage';

import { PlayfulReviewList } from '../../components/Reviews/PlayfulReviewList';
import { About } from './components/About';
import { CancellationPolicySection } from './components/CancellationPolicySection';
import { PlayfulBusinessHoursSection } from './components/PlayfulBusinessHoursSection';

const PlayfulAbout = () => {
  const {
    showReviews,
    aboutText,
    hasCancellationPolicy,
    professionals,
    handleBook,
    showTeam,
  } = useAboutPage();

  return (
    <>
      <main>
        <About aboutText={aboutText} />
        <PlayfulBusinessHoursSection />
        {hasCancellationPolicy && <CancellationPolicySection />}
        {showTeam && (
          <TextureSection title="Team">
            <PlayfulTeamList
              professionals={professionals}
              onProfessionaClick={handleBook}
            />
            <CtaViewMore to="/team" title="View full team" />
          </TextureSection>
        )}
        {showReviews && <PlayfulReviewList />}
        <CtaBookNow />
      </main>
    </>
  );
};

export { PlayfulAbout };
